import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { List, ListItem, ListItemIcon, Stack, Text } from 'components/ui';
import type { AuthPasswordRequirementsProps } from './AuthPasswordRequirements.props';
import {
  authPasswordRequirementsItemIconSx,
  authPasswordRequirementsItemSx,
  authPasswordRequirementsItemTextSx,
  authPasswordRequirementsListSx,
  authPasswordRequirementsMetIconSx,
  authPasswordRequirementsTitleSx,
  authPasswordRequirementsUnmetIconSx,
} from './AuthPasswordRequirements.styles';

const AuthPasswordRequirements = ({ items, title }: AuthPasswordRequirementsProps) => (
  <Stack spacing={1}>
    <Text sx={authPasswordRequirementsTitleSx} variant="body2">
      {title}
    </Text>
    <List disablePadding sx={authPasswordRequirementsListSx}>
      {items.map(item => (
        <ListItem disableGutters key={item.label} sx={authPasswordRequirementsItemSx}>
          <ListItemIcon sx={authPasswordRequirementsItemIconSx}>
            {item.isMet ? (
              <CheckCircleIcon sx={authPasswordRequirementsMetIconSx} />
            ) : (
              <CheckCircleOutlinedIcon sx={authPasswordRequirementsUnmetIconSx} />
            )}
          </ListItemIcon>
          <Text
            sx={authPasswordRequirementsItemTextSx}
            variant="body2"
          >
            {item.label}
          </Text>
        </ListItem>
      ))}
    </List>
  </Stack>
);

export default AuthPasswordRequirements;
